var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// <reference path="../Company.tsx" />
import { useFormik } from 'formik';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import styles from './styles.module.scss';
import { Button } from 'template/lib';
import { useEffect, useState } from 'react';
import RelatorioTemplate from '../../Interation/RelatorioTemplate';
import { renderToString } from "react-dom/server";
// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');
var ModalAceite = function (props) {
    var _a = useState(false), signed = _a[0], setSigned = _a[1];
    useEffect(function () {
        setSigned(false);
        if (props.countInteration !== undefined) {
            if (props.countInteration.signedCount + 1 === props.countInteration.totalCount) {
                setSigned(true);
            }
        }
    }, [props.countInteration]);
    var login = useAuth().login;
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    var formik = useFormik({
        initialValues: {
            city: '',
            street: '',
            district: '',
            number: '',
            zipcode: ''
        },
        onSubmit: function () { return __awaiter(void 0, void 0, void 0, function () {
            var responseUpdate, error_1, idItem, responseSign, error_2, pdfResponse, relatorioHTML, html, iframe_1, conteudo, doc, error_3, err_1;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 13, , 14]);
                        if (!signed) return [3 /*break*/, 4];
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.get("/signature/updateInteration/" + props.idSelect, config)];
                    case 2:
                        responseUpdate = _f.sent();
                        props.mensage(responseUpdate.data.message);
                        props.handleCloseModalEdit();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _f.sent();
                        console.error("Erro ao atualizar a iteração:", error_1);
                        alert("Erro ao atualizar a iteração");
                        return [2 /*return*/];
                    case 4:
                        idItem = props.idItem;
                        _f.label = 5;
                    case 5:
                        _f.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, api.post("/signature/signatureItem", { idItem: idItem }, config)];
                    case 6:
                        responseSign = _f.sent();
                        props.mensage(responseSign.data);
                        return [3 /*break*/, 8];
                    case 7:
                        error_2 = _f.sent();
                        console.error("Erro ao assinar o item:", ((_a = error_2.response) === null || _a === void 0 ? void 0 : _a.data) || error_2.message);
                        alert("Erro ao assinar o item: " + (((_b = error_2.response) === null || _b === void 0 ? void 0 : _b.data) || error_2.message));
                        return [2 /*return*/];
                    case 8:
                        if (!signed) return [3 /*break*/, 12];
                        _f.label = 9;
                    case 9:
                        _f.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, api.get("/signature/pdfAll/" + props.idSelect, config)];
                    case 10:
                        pdfResponse = _f.sent();
                        relatorioHTML = _jsx(RelatorioTemplate, __assign({}, pdfResponse.data), void 0);
                        html = renderToString(relatorioHTML);
                        iframe_1 = document.createElement("iframe");
                        iframe_1.style.position = "fixed";
                        iframe_1.style.right = "0";
                        iframe_1.style.bottom = "0";
                        iframe_1.style.width = "0";
                        iframe_1.style.height = "0";
                        iframe_1.style.border = "none";
                        iframe_1.setAttribute("aria-hidden", "true");
                        document.body.appendChild(iframe_1);
                        conteudo = "\n          <html>\n            <body>" + html + "</body>\n          </html>\n        ";
                        doc = iframe_1.contentDocument || ((_c = iframe_1.contentWindow) === null || _c === void 0 ? void 0 : _c.document);
                        if (!doc) {
                            console.error("Não foi possível acessar o documento do iframe.");
                            return [2 /*return*/];
                        }
                        doc.open();
                        doc.write(conteudo);
                        doc.close();
                        // Aguarda o conteúdo ser renderizado e imprime
                        setTimeout(function () {
                            var win = iframe_1.contentWindow;
                            if (win) {
                                win.focus();
                                win.print();
                            }
                            setTimeout(function () { return iframe_1.remove(); }, 1000);
                        }, 500);
                        return [3 /*break*/, 12];
                    case 11:
                        error_3 = _f.sent();
                        console.error("Erro ao gerar PDF:", ((_d = error_3.response) === null || _d === void 0 ? void 0 : _d.data) || error_3.message);
                        alert("Erro ao gerar PDF: " + (((_e = error_3.response) === null || _e === void 0 ? void 0 : _e.data) || error_3.message));
                        return [3 /*break*/, 12];
                    case 12:
                        props.handleCloseModalEdit();
                        return [3 /*break*/, 14];
                    case 13:
                        err_1 = _f.sent();
                        console.error("Erro inesperado:", err_1);
                        alert('Ocorreu um erro inesperado');
                        return [3 /*break*/, 14];
                    case 14: return [2 /*return*/];
                }
            });
        }); },
    });
    var columns = 1;
    return (_jsx("div", __assign({ className: 'h-24' }, { children: _jsx(Modal, __assign({ isOpen: props.handleOpenModalEdit, shouldCloseOnOverlayClick: false, onRequestClose: props.handleCloseModalEdit, overlayClassName: 'react-modal-overly', className: 'react-modal-content', contentLabel: "Example Modal" }, { children: _jsxs("div", __assign({ className: '' }, { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx("h2", __assign({ className: ' font-semibold border-b-2 text-lg' }, { children: "Aceite de Servi\u00E7os \u2013 WPS" }), void 0), _jsx(AiOutlineClose, { title: 'Fechar', className: 'cursor-pointer text-sm', onClick: props.handleCloseModalEdit }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.content }, { children: _jsxs("form", __assign({ onSubmit: formik.handleSubmit, className: 'mx-4 my-4' }, { children: [_jsx("div", __assign({ className: 'grid justify-items-start' }, { children: _jsx("div", __assign({ className: "grid grid-cols-1 md:grid-cols-" + columns + " lg:grid-cols-" + columns + " my-2 justify-items-end" }, { children: _jsx("p", { children: "Ao clicar em \u201CAceito\u201D, declaro que recebi e estou de acordo que os servi\u00E7os prestados foram conclu\u00EDdos conforme o solicitado, atendendo aos padr\u00F5es de qualidade e prazos estabelecidos. Ap\u00F3s an\u00E1lise e valida\u00E7\u00E3o, n\u00E3o foram identificadas pend\u00EAncias, sendo assim, o servi\u00E7o \u00E9 considerado aceito e devidamente finalizado." }, void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: styles.flexButton }, { children: _jsx(Button, __assign({ type: 'submit', className: '' }, { children: "Aceito" }), void 0) }), void 0)] }), void 0) }), void 0)] }), void 0) }), void 0) }), void 0));
};
export default ModalAceite;
